export const _support = true;
export {_driver} from './_driver';
export {_initStorage} from './_initStorage';
export {clear} from './clear';
export {dropInstance} from './dropInstance';
export {getItem} from './getItem';
export {iterate} from './iterate';
export {key} from './key';
export {keys} from './keys';
export {length} from './length';
export {removeItem} from './removeItem';
export {setItem} from './setItem';
